import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { Content } from './Content'

type Props = {
  userIds: string[]
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content userIds={props.userIds} />
    </Modal>
  )
}
